// Lightweight fire-and-forget signup funnel tracker.
// Persists to public.signup_analytics_events via /api/public/track-signup.

const SESSION_KEY = 'ndlcs:sa-session';

function getSessionId(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    let id = window.sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      const fresh =
        (crypto as any)?.randomUUID?.() ??
        `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      window.sessionStorage.setItem(SESSION_KEY, fresh);
      id = fresh;
    }
    return id ?? undefined;
  } catch {
    return undefined;
  }
}

export type SignupEventType = 'signup_click' | 'signup_completed';

export function trackSignupEvent(
  event_type: SignupEventType,
  source: string,
  extra: { user_id?: string; metadata?: Record<string, unknown> } = {},
): void {
  if (typeof window === 'undefined') return;
  const payload = {
    event_type,
    source,
    session_id: getSessionId(),
    user_id: extra.user_id,
    path: window.location?.pathname + (window.location?.search ?? ''),
    referrer: document?.referrer || undefined,
    metadata: extra.metadata ?? {},
  };
  try {
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon('/api/public/track-signup', blob);
      return;
    }
    fetch('/api/public/track-signup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}
